// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EJ1wh","newExpiryDate":"styles_newExpiryDate__27KE5","footer":"styles_footer__17sF_"};